export default __webpack_public_path__ + "static/1-9fe30ebb2f25073566df09e443405a1a.jpg";